import { createContext, ReactNode } from 'react';

export type PopupHost = {
  isHomePage?: boolean;
  productSlug?: string;
  categorySlug?: string;
  brandSlug?: string;
};

interface PopupControllerValue {
  initiate: (host: PopupHost) => void;
  cancel: () => void;
}

export const PopupControllerContext = createContext<PopupControllerValue>({
  initiate: (_) => {},
  cancel: () => {},
});

interface PopupControllerProps extends PopupControllerValue {
  children?: ReactNode;
}

export const PopupController = ({
  children,
  ...props
}: PopupControllerProps) => {
  return (
    <PopupControllerContext.Provider value={props}>
      {children}
    </PopupControllerContext.Provider>
  );
};
